module.exports = __webpack_public_path__ + "static/media/pdf-logo.d1517fa9.svg";